import React, { Component } from 'react';
import { Link } from 'react-router';

import OrganizationStore from "../../stores/OrganizationStore";
import SessionStore from "../../stores/SessionStore";
import OrganizationForm from "../../components/OrganizationForm";

class UpdateOrganization extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.state = {
      organization: {},
      isAdmin: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    OrganizationStore.getOrganization(this.props.params.id, (organization) => {
      this.setState({
        organization: organization,
      });
    });

    this.setState({
      isAdmin: SessionStore.isAdmin(),
    });

    SessionStore.on("change", () => {
      this.setState({
        isAdmin: SessionStore.isAdmin(),
      });
    });
  }

  onSubmit(organization) {
    OrganizationStore.updateOrganization(this.props.params.id, organization, (responseData) => {
      this.context.router.push('organizations');
    });
  }

  // onDelete() {
  //   if (confirm("Are you sure you want to delete this organization?")) {
  //     OrganizationStore.deleteOrganization(this.props.params.id, (responseData) => {
  //       this.context.router.push('/organizations');
  //     });
  //   }
  // }
  onDelete() {
    if (confirm("Are you sure you want to delete this organization?")) {
      const dialog = document.createElement('div');
      dialog.style.position = 'fixed';
      dialog.style.top = '50%';
      dialog.style.left = '50%';
      dialog.style.transform = 'translate(-50%, -50%)';
      dialog.style.backgroundColor = 'white';
      dialog.style.padding = '20px';
      dialog.style.border = '1px solid black';
      dialog.style.textAlign = 'center';
  
      const countdownElementDescription = document.createElement('p');
      countdownElementDescription.textContent = `Are you sure to delete it?`;
      countdownElementDescription.style.fontSize= '24px'
      countdownElementDescription.style.margin = '0';
      countdownElementDescription.style.color = 'red'
      dialog.appendChild(countdownElementDescription);
  


      const countdownElement = document.createElement('p');
      countdownElement.textContent = ` 10`;
      countdownElement.style.fontSize= '80px'
      countdownElement.style.color = 'red'
      countdownElement.style.margin = '0';
      dialog.appendChild(countdownElement);


      const confirmBtn = document.createElement('button');
      confirmBtn.textContent = 'Yes';
      confirmBtn.style.backgroundColor = '#cccccc';
      confirmBtn.style.color = '#999999';
      confirmBtn.style.marginRight = '10px';
      confirmBtn.style.cursor = 'not-allowed';
      confirmBtn.style.width = '100px';
      confirmBtn.style.height = '36px';
      confirmBtn.setAttribute('disabled', 'disabled');
      confirmBtn.disabled = true;
      confirmBtn.style.margin = '0';
      dialog.appendChild(confirmBtn);
  
      const cancelBtn = document.createElement('button');
      cancelBtn.style.width = '100px';
      cancelBtn.style.height = '36px';
      cancelBtn.textContent = 'Cancel';
      cancelBtn.style.margin = '0';
      cancelBtn.style.marginLeft = '10px'
      dialog.appendChild(cancelBtn);
  
      document.body.appendChild(dialog);
  
      let countdown = 10;
  
      const timer = setInterval(() => {
        countdown--;
        countdownElement.textContent = `${countdown}`;
        if (countdown <= 0) {
          clearInterval(timer);
          confirmBtn.disabled = false;
          confirmBtn.style.backgroundColor = '#0061E0';
          confirmBtn.style.color = 'white';
          confirmBtn.style.cursor = 'default';
          countdownElementDescription.style.marginBottom = '40px';
          countdownElementDescription.textContent = 'Are you sure to delete it?'
          countdownElement.textContent = '';
        }
      }, 1000);
  
      confirmBtn.addEventListener('click', () => {
        OrganizationStore.deleteOrganization(this.props.params.id, (responseData) => {
          this.context.router.push('/organizations');
        });
        document.body.removeChild(dialog);
      });
  
      cancelBtn.addEventListener('click', () => {
        document.body.removeChild(dialog);
      });
    }
  }
  
  render() {
    return(
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><Link to={`/organizations/${this.props.params.id}`}>{this.state.organization.displayName}</Link></li>
          <li className="active">Edit organization</li>
        </ol>
        <div className="clearfix">
          <div className={'btn-group pull-right ' + (this.state.isAdmin ? '' : 'hidden')} role="group" aria-label="...">
            <Link><button type="button" className="btn btn-danger" onClick={this.onDelete}>Delete organization</button></Link>
          </div>
        </div>
        <hr />
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <OrganizationForm organization={this.state.organization} onSubmit={this.onSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default UpdateOrganization;



// WEBPACK FOOTER //
// ./src/views/organizations/UpdateOrganization.js